import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Schema from 'componentsV2/Schema';
import { SCHEMA_TYPES } from 'componentsV2/Schema/SchemaHelper';
import Links from './Links';
import {
  articleDetailParser,
  browseParser,
  channelParser,
  collectionParser,
  liveParser,
  seriesDetailParser,
  watchParser,
  watchlistParser,
} from './BreadcrumbsDataParsers';
import Style from './Breadcrumbs.module.scss';

export const breadcrumbsArticleDetailParser = articleDetailParser;
export const breadcrumbsChannelParser = channelParser;
export const breadcrumbsCollectionParser = collectionParser;
export const breadcrumbsLiveParser = liveParser;
export const breadcrumbsSeriesDetailParser = seriesDetailParser;
export const breadcrumbsBrowseParser = browseParser;
export const breadcrumbsWatchParser = watchParser;
export const breadcrumbsWatchlistParser = watchlistParser;

const Breadcrumbs = ({ data, theme = null, customStyle = null, disableH1 = false }) => {
  if (!data) return null;
  const filteredData = data.filter(value => !!value?.name);
  return (
    <div
      data-testid="breadcrumbs"
      className={classNames([Style.container, theme.container, customStyle])}
    >
      <Schema schemas={[{ item: filteredData, type: SCHEMA_TYPES.BREADCRUMBS }]} />
      <Links data={filteredData} theme={theme} disableH1={disableH1} />
    </div>
  );
};

Breadcrumbs.defaultProps = {
  data: [],
  theme: {},
  customStyle: '',
};

Breadcrumbs.propTypes = {
  customStyle: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({}), PropTypes.bool])),
  disableH1: PropTypes.bool,
  theme: PropTypes.shape({}),
};

export default Breadcrumbs;
